import styled from 'styled-components'
import { Box } from '@mui/material'

const CONTENT_MARGIN = 12

const ContentWrap = styled(Box)`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: ${CONTENT_MARGIN}px;
`

export default ContentWrap
